const DAY_IN_MS = 24 * 3600 * 1000;

export const boxStyle = {
	bgcolor: 'background.paper',
	boxShadow: 1,
	p: 2,
	width: { sm: '100%', md: .25 }
};

export const normalizeFilterForm = (filter) => {
	switch (filter?.date_range) {
		case 'today':
			filter.start_date = filter.end_date = relativeTimestamp(0);
			break;

		case 'yesterday':
			filter.start_date = filter.end_date = relativeTimestamp(-1);
			break;

		case 'week':
			filter.start_date = relativeTimestamp(-7);
			filter.end_date = relativeTimestamp(0);
			break;

		case 'thirty':
			filter.start_date = relativeTimestamp(-30);
			filter.end_date = relativeTimestamp(0);
			break;

		case 'month':
			var endDate = new Date();
			endDate.setDate(-0);
			filter.end_date = timestamp(endDate);

			var startDate = new Date(endDate);
			startDate.setDate(1);
			filter.start_date = timestamp(startDate);
			break;

		default:

	}

	delete filter.date_range;

	if ( !Array.isArray( filter.metrics ) ) {
		filter.metrics = filter.metrics ? [ filter.metrics ] : [];
	}

	if ( !Array.isArray( filter.session_id ) ) {
		filter.session_id = filter.session_id ? [ filter.session_id ] : [];
	}

	return filter;
}

export function relativeTimestamp(days) {
	days = days || 0;
	let ts = Date.now() + (days * DAY_IN_MS);
	const date = new Date(ts);
	return timestamp(date);
}

export function timestamp(date) {
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	return `${year}-${month}-${day}`;
}
